import { FormValues } from './company-dialog.form';
import { CompanyDialogCore, DialogProps } from './company-dialog';
import { CompanyDto, EMPTY_CONTACTS, UpdateCompanyDto } from '@sr/dto';

interface EditDialogProps extends DialogProps<UpdateCompanyDto> {
  company: CompanyDto;
}

export const EditCompanyDialog = (props: EditDialogProps) => {
  const { open, onClose, onSubmit, company } = props;

  const handleSubmit = async (values: FormValues) => {
    if (!values.cityId) {
      throw new Error('Город обязателен для заполнения');
    }
    const updateCompanyData: UpdateCompanyDto = {
      id: company.id,
      name: values.name,
      isClient: values.isClient,
      isSupplier: values.isSupplier,
      isMedia: values.isMedia,
      isCompetitor: values.isCompetitor,
      cityId: values.cityId,
      okved: company.okved || [],
      okvedIds: values.okvedIds
    };

    if (values.cityId) {
      updateCompanyData.cityId = values.cityId;
    }

    await onSubmit(updateCompanyData);
    onClose();
  };

  const provideFormInitialValues = (): FormValues => {
    return {
      name: company.name,
      isClient: company.isClient,
      isSupplier: company.isSupplier,
      isMedia: company.isMedia,
      isCompetitor: company.isCompetitor,
      cityId: company.cityId,
      companyContacts: EMPTY_CONTACTS,
      okvedIds: company.okvedIds || []
    };
  };

  return <CompanyDialogCore open={open} onClose={onClose} title="Редактирование фирмы" formInitialValues={provideFormInitialValues} handleSubmit={handleSubmit} />;
};
